import { render, staticRenderFns } from "./EditXMLImport.vue?vue&type=template&id=1d70f4b2&scoped=true&"
import script from "./EditXMLImport.vue?vue&type=script&lang=js&"
export * from "./EditXMLImport.vue?vue&type=script&lang=js&"
import style0 from "./EditXMLImport.vue?vue&type=style&index=0&id=1d70f4b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d70f4b2",
  null
  
)

export default component.exports